<template>
  <div>
    <div style="text-align: center" class="title justify-center">
      <p>{{ title }} <br /> {{ subtitle }}</p>
    </div>
    <v-container fluid grid-list-md class="Ranking_Recebimento pt-0 pb-2">
      <v-data-iterator
        :items="lista"
        hide-default-footer>
        <template v-slot:default="props">
          <v-row align="start" justify="center">
            <v-col cols="12"
              class="pt-0 pl-0"
              v-for="(item, index) in props.items"
              :key="index">
              <v-hover>
                <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 5 : 1}`" fill-height>
                  <v-card-title class="Card_Title">
                    <span>
                      {{ item.posicao }}º {{ capitalize(item.titulo) }}
                    </span>
                  </v-card-title>
                  <v-card-text class="Card_Content">
                    <p nowrap>
                      {{ getMoney(item.valorRecebimento) }}
                    </p>
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-container>
  </div>
</template>

<script>
import {
  getMoney,
  capitalize,
} from '@/common/functions/helpers';
import {
  listarRankingRecebimentosPorGrupoFornecedor,
  listarRankingRecebimentosPorSetor,
} from '@/common/resources/recebimento';

export default {
  name: 'DashboardInicialRankingRecebimento',
  components: {
  },
  props: {
    filtros: Object,
    origem: String,
    title: String,
    subtitle: String,
  },
  data() {
    return {
      lista: [],
      filtrosAplicados: this.filtros,
    };
  },
  watch: {
    filtros: {
      handler() {
        this.filtrosAplicados = this.filtros;
        this.buscar();
      },
    },
  },
  computed: {
  },
  methods: {
    getMoney,
    capitalize,

    buscar() {
      const params = {
        ...this.filtrosAplicados,
        tamanhoPagina: 7,
      };

      const promise = this.origem === 'setor'
        ? listarRankingRecebimentosPorSetor(params, this.$resource)
        : listarRankingRecebimentosPorGrupoFornecedor(params, this.$resource);

      promise.then((response) => {
        this.lista = response.data;
      })
        .catch((err) => {
          this.$error(this, err);
        });
    },
  },
  beforeMount() {
  },
  mounted() {
    this.filtrosAplicados = this.filtros;
  },
};
</script>

<style>
.Ranking_Recebimento .Card_Title {
  padding: 7px 7px 0px 7px ;
}
.Ranking_Recebimento .Card_Content {
  padding: 0px 7px 7px 7px ;
}
.Ranking_Recebimento .Card_Title, .Ranking_Recebimento .Card_Content {
  color: #757575;
  display: block;
}
.Ranking_Recebimento .Card_Title, .Ranking_Recebimento .Card_Content span {
  font-weight: 700;
  margin: 0px;
  font-size: 16px;
}
.Ranking_Recebimento .Card_Content p {
  font-size: 1.4em;
  font-weight: 300;
  margin: 0px;
}
.Ranking_Recebimento .clickable {
  cursor: pointer;
}
</style>
